import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Frown, Smartphone, MessageCircle } from 'lucide-react';
export function PainSection() {
  return <section className="py-16 px-4 bg-[#FDFBF7]" data-id="element-421" data-mp="38vu8yc6q8d5p">
      <div className="max-w-lg md:max-w-2xl mx-auto" data-id="element-422" data-mp="2uyx8rk4pxjc5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-423" data-mp="2v08ehphq515w">
          <h2 className="text-2xl md:text-3xl font-bold text-[#D84315] mb-8 leading-snug" data-id="element-424" data-mp="2pzc8959wh2xb">
            Para la mamá que prepara algo con amor… y termina tirándolo a la
            basura.
          </h2>

          <div className="space-y-6 text-gray-700 text-lg" data-id="element-425" data-mp="2g8hihqxg3l74">
            <p data-id="element-426" data-mp="229hwys58bmf6">Eran las 12 del mediodía.</p>
            <p data-id="element-427" data-mp="22ajar4dmqn0l">
              Habías despertado temprano. Habías pensado en qué cocinar mientras
              te duchababas. Habías comprado algo más de verdura esta semana
              porque querías hacerlo mejor.
            </p>
            <p data-id="element-428" data-mp="3rp3tswn0c1p3">Pusiste el plato en la mesa.</p>
            <p className="font-bold text-gray-900" data-id="element-429" data-mp="3nlyv7561sk5q">
              Y tu hijo lo miró como si le hubieras servido veneno.
            </p>
            <p data-id="element-430" data-mp="5fapbd36bsz0">Ese silencio. Esa carita. Ese "no quiero esto."</p>
            <p className="italic text-gray-600" data-id="element-431" data-mp="gg6wc94c6ff">
              Y ahí apareció la pregunta que más duele: ¿Estoy fallando como
              mamá?
            </p>

            <div className="py-6 flex justify-center" data-id="element-432" data-mp="38u6m3awuk2cg">
              <div className="w-16 h-1 bg-[#FFCC80] rounded-full" data-id="element-433" data-mp="33yrbqsy1soks"></div>
            </div>

            <h3 className="text-xl font-bold text-gray-900" data-id="element-434" data-mp="3ine1lolawyq9">
              No estás fallando.
            </h3>
            <p data-id="element-435" data-mp="3duufu4cgmxad">
              Estás improvisando. Y la improvisación, aunque venga del mejor
              lugar del mundo, genera exactamente lo que estás viviendo: caos,
              rechazo, culpa y agotamiento.
            </p>

            <div className="bg-[#FFF3E0] p-6 rounded-2xl my-8 border border-[#FFE0B2]" data-id="element-436" data-mp="2l549ihh2kzot">
              <p className="text-xl font-bold text-[#E65100] text-center italic" data-id="element-437" data-mp="p1prpd506a8k">
                "Tu hijo no rechaza la comida. Rechaza el caos."
              </p>
            </div>

            <p data-id="element-438" data-mp="yu58460niqrc">Y eso tiene solución.</p>

            <div className="py-6 flex justify-center" data-id="element-439" data-mp="12v78wra7vavf">
              <div className="w-16 h-1 bg-[#FFCC80] rounded-full" data-id="element-440" data-mp="12up6fcwyo0f2"></div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-441" data-mp="669e592gvcy9">
              Imagina un martes cualquiera.
            </h3>

            <div className="space-y-6" data-id="element-442" data-mp="b659kjx3lw27">
              <div className="flex gap-4 items-start" data-id="element-443" data-mp="f54l4ndc4r2m">
                <div className="bg-[#FFCC80] p-3 rounded-full shrink-0 mt-1" data-id="element-444" data-mp="f7qsalwbd4kb">
                  <Clock className="w-6 h-6 text-[#E65100]" data-id="element-445" data-mp="k6agksydqsfu" />
                </div>
                <p data-id="element-446" data-mp="1qjrnojnonr91">
                  Son las 7 AM. Hay que preparar el desayuno, llevar al cole,
                  contestar mensajes, llegar al trabajo. Ya estás en modo
                  automático.
                </p>
              </div>

              <div className="flex gap-4 items-start" data-id="element-447" data-mp="25pnlgw81myr0">
                <div className="bg-[#FFCC80] p-3 rounded-full shrink-0 mt-1" data-id="element-448" data-mp="20prhuy39d9bz">
                  <Frown className="w-6 h-6 text-[#E65100]" data-id="element-449" data-mp="1vxhsbj622ba8" />
                </div>
                <p data-id="element-450" data-mp="1rwo6qwg358ki">
                  A las 12 vuelves y toca cocinar. ¿Qué hay en la heladera? Lo
                  mismo de siempre. No hay tiempo de pensar algo "nuevo y
                  nutritivo". Pones lo que hay. Tu hijo come la mitad. O no come
                  nada. O come solo el pan. Tú insistes un poco. Él se cierra.
                  Se convierte en negociación. En pelea. En culpa.
                </p>
              </div>

              <div className="flex gap-4 items-start" data-id="element-451" data-mp="18yvf4qawwl2f">
                <div className="bg-[#FFCC80] p-3 rounded-full shrink-0 mt-1" data-id="element-452" data-mp="37d6l4r5zq4iy">
                  <Smartphone className="w-6 h-6 text-[#E65100]" data-id="element-453" data-mp="37b2dby4z0lde" />
                </div>
                <p data-id="element-454" data-mp="33ccxlywgmrql">
                  Por la noche abres Instagram y ves a una mamá con un bowl de
                  colores perfectos, con faces sonrientes de sus hijos, y
                  piensas:{' '}
                  <span className="italic" data-id="element-455" data-mp="3fbrxi7pahd9a">
                    ¿Cómo lo hace ella? ¿Por qué yo no puedo?
                  </span>
                </p>
              </div>
            </div>

            <div className="mt-10 bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-456" data-mp="35dveyuu0vg15">
              <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-457" data-mp="2rmp5c5x1420j">
                <MessageCircle className="w-5 h-5 text-gray-400" data-id="element-458" data-mp="2wfs36q8u9xmj" />Y encima está
                el ruido de fondo:
              </h4>
              <ul className="space-y-3 text-gray-600" data-id="element-459" data-mp="2ho15mn8ww9ln">
                <li className="flex items-start gap-2" data-id="element-460" data-mp="2mq8jxjh7s1r5">
                  <span className="text-[#FF8A65] font-bold" data-id="element-461" data-mp="28pflworpeoja">•</span>
                  Tu suegra que dice "antes se comía de todo sin problema"
                </li>
                <li className="flex items-start gap-2" data-id="element-462" data-mp="2dnz7go2dxyb4">
                  <span className="text-[#FF8A65] font-bold" data-id="element-463" data-mp="1u2777dz6s12k">•</span>
                  El pediatra que da una lista y no dice cómo
                </li>
                <li className="flex items-start gap-2" data-id="element-464" data-mp="1p5gun0mlbnlw">
                  <span className="text-[#FF8A65] font-bold" data-id="element-465" data-mp="233ngfie9lx57">•</span>
                  El gurú de Instagram que hoy dice que el gluten es malo y
                  mañana que es bueno
                </li>
                <li className="flex items-start gap-2" data-id="element-466" data-mp="2d0jgr0u0fcyo">
                  <span className="text-[#FF8A65] font-bold" data-id="element-467" data-mp="2cz8h9d7lkrdd">•</span>
                  Tus propias dudas que no te dejan dormir
                </li>
              </ul>
            </div>

            <div className="mt-10 p-6 bg-[#FFEBEE] rounded-2xl border border-[#FFCDD2] text-center" data-id="element-468" data-mp="2mth2rgy7nk21">
              <p className="text-xl font-bold text-[#C62828]" data-id="element-469" data-mp="2hue88qfuww8b">
                El resultado: comes ansiosa, cocinas con culpa, y la mesa se
                convierte en campo de batalla.
              </p>
              <p className="mt-4 text-[#C62828] font-medium" data-id="element-470" data-mp="2qr516tz43uyo">
                ¿Te suena conocido?
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}